import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { DestroyService } from '@app/core/services/destroy.service'
import { ServiceRecord } from '../service-record/service-record.model'
import dayjs from 'dayjs'

@Component({
  selector: 'lin-service-record-edit-dialog',
  templateUrl: './service-record-edit-dialog.component.html',
  styleUrls: ['./service-record-edit-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DestroyService],
  standalone: false,
})
export class ServiceRecordEditDialogComponent implements OnInit {
  form: FormGroup

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ServiceRecord,
    public dialogRef: MatDialogRef<ServiceRecordEditDialogComponent>,
    private fb: FormBuilder,
  ) {}

  ngOnInit(): void {
    const { data } = this

    this.form = this.fb.group({
      date: dayjs(data.date).tz(),
      odometer: data.odometer ? [data.odometer / 1000, Validators.required] : null,
      engineHours: data.engineHours ? [data.engineHours, Validators.required] : null,
      cost: data.cost,
      note: data.note,
      files: data.files,
      removeFiles: [[]],
    })
  }

  removeFile(id: number) {
    const removeFiles = this.form.get('removeFiles')
    const removeIds = removeFiles.value as number[]
    removeFiles.setValue(removeIds.concat([id]))
    removeFiles.markAsDirty()
  }

  submitForm() {
    /* eslint-disable */
    const formData = this.form.value

    const toKilometers = (mileageM: number) => mileageM * 1000

    let data = {
      date: dayjs(formData.date).tz().hour(0).minute(0).second(0).format(),
      engineHours: formData.engineHours || '',
      odometer: formData.odometer ? toKilometers(formData.odometer) : '',
      cost: formData.cost,
      note: formData.note,
      files: formData.files,
      removeFiles: formData.removeFiles,
    }
    /* eslint-enable */

    this.dialogRef.close(data)
  }
}
